const key = {
  SET_USER: "SET_USER",
  SHOW_TOAST: "SHOW_TOAST",
  CLOSE_TOAST: "CLOSE_TOAST",
  SET_MENUS: "SET_MENUS",
  MODAL_LOGIN: "MODAL_LOGIN",
  MODAL_LIVE: "MODAL_LIVE",
  MODAL_BAN: "MODAL_BAN",
  SIGN_KEY: "SIGN_KEY",
  LOG_OUT: "LOG_OUT"
}

export default key
